import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppForm } from '../../features/apps/models/app.model';
import { UICardModule } from '@homepower-co/shared-ui-angular';

@Component({
  selector: 'app-app-summary-card',
  standalone: true,
  imports: [CommonModule, UICardModule],
  templateUrl: './app-summary-card.component.html',
  styleUrls: ['./app-summary-card.component.scss'],
})
export class AppSummaryCardComponent {
  @Input() apps: AppForm[] = [];

  currentIndex = 0;

  get currentApp(): AppForm | null {
    return this.apps?.length ? this.apps[this.currentIndex] : null;
  }

  get carouselIndicators() {
    // Return max 3 indicators, or less if fewer apps
    const count = Math.min(this.apps?.length || 0, 3);
    return new Array(count).fill(0);
  }

  get currentIndicatorIndex(): number {
    // Map current index to 0, 1, or 2
    return this.currentIndex % 3;
  }

  nextApp() {
    if (!this.apps?.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.apps.length;
  }

  prevApp() {
    if (!this.apps?.length) return;
    this.currentIndex =
      (this.currentIndex - 1 + this.apps.length) % this.apps.length;
  }

  changeCarouselIndex(indicatorIndex: number) {
    // If user clicks indicator 2, we want to jump to the next app that corresponds to slot 2.
    // However, with modulo logic it's ambiguous. Essential behavior is "jump to a page".
    // For simplicity with modulo logic, let's just set currentIndex = indicatorIndex if it's within first page,
    // or maybe just do nothing, or keep simpler logic.
    // User asked "solo se muestren 3 botones", usually implies simply 3 dots cycling.
    // Let's assume clicking a dot jumps to that relative position in the current "page" or starts over.
    // Safest: Jump to the indicator index directly (0, 1, 2).
    if (indicatorIndex < (this.apps?.length || 0)) {
      this.currentIndex = indicatorIndex;
    }
  }
}
